"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useLocale, useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import React, { FC, useContext, useState } from "react";

import AddToFavorites from "@/components/AddToFavorites/AddToFavorites";
import Pagination from "@/components/AvailableUnitsList/Pagination";
import UnitDetails from "@/components/AvailableUnitsList/UnitDetails";
import Icon from "@/components/ui/Icon/Icon";
import ModalContent from "@/components/ui/Modal/ModalContent";
import useMediaQuery from "@/hooks/useMediaQuery";
import { CommercetoolsUnit } from "@/types";

import FormattedPrice from "./FormattedPrice";
import MobileFilters from "./MobileFilters";

const Modal = dynamic(() => import("@/components/ui/Modal/Modal"), { ssr: false });
interface Props {
  isBelongToCommunity?: boolean | void;
  matchedCommunity?: any;
}
const UnitsTable: FC<Props> = ({ isBelongToCommunity, matchedCommunity }) => {
  const t = useTranslations();
  const [selectedUnit, setSelectedUnit] = useState<CommercetoolsUnit | null>();
  const formatUnitName = (name: string): string => name.replaceAll("/", "-") || name;
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const locale = useLocale();
  const [language, _] = locale.split("-");

  return (
    <>
      <div className="md:hidden">
        <div className="grid units-grid border-b border-b-gray-10 mb-m gap-xs px-m py-m">
          <div className={`font-secondary font-medium text-s uppercase ${language === "ar" ? "mr-[40px]" : "ml-[10px]"}`}>{t("aul.unitID")}</div>
          <div className={`font-secondary font-medium text-s uppercase ${language === "ar" ? "mr-[40px]" : ""}`}>{t("aul.unitType")}</div>
          <div className={`font-secondary font-medium text-s uppercase ${language === "ar" ? "mr-[40px]" : ""}`}>{t("aul.price")}</div>
        </div>
        <AnimatePresence></AnimatePresence>
        <Pagination />
      </div>
      {selectedUnit && (
        <Modal
          open={!!selectedUnit}
          onClose={() => {
            setSelectedUnit(null);
          }}
        >
          <ModalContent className="h-svh !p-0 w-full">
            <div className="h-dvh flex flex-col">
              <header className="flex justify-between p-m border-b border-b-gray-10 md:hidden">
                <h3>{t("aul.unitDetails")}</h3>
                <div className="flex items-center gap-m">
                  {/* <button className="">
                    <Icon
                      className="stroke-black"
                      name="heart-empty"
                      size="24"
                      title={t("button.label.addToFavourite")}
                      fill={false ? "fill-black" : ""}
                    />
                  </button> */}
                  <AddToFavorites item={selectedUnit} className="flex" fillColor="fill-black" />
                  <button
                    onClick={() => {
                      setSelectedUnit(null);
                    }}
                    className="font-secondary text-s underline"
                  >
                    <Icon className="stroke-black" name="close" size="24" title={t("button.label.close")} fill={false ? "fill-black" : ""} />
                  </button>
                </div>
              </header>
              <UnitDetails
                closeHandler={() => {
                  setSelectedUnit(null);
                }}
                unit={selectedUnit!}
                customClass="pt-l grow relative flex flex-col grow"
                isBelongToCommunity={isBelongToCommunity}
                matchedCommunity={matchedCommunity}
              />
            </div>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};
export default UnitsTable;
